import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import MainWrapper from "../../helpers/MainWrapper";
import MainHeader from "./MainHeader";
import ContactSection from "./ContactSection";
import "./styles.less";

declare var root: any;

const RequestOffer = () => {
  return (
    <>
      <MainWrapper menus={true}>
        <MainHeader />
        <ContactSection />
      </MainWrapper>
    </>
  );
};

if (root) {
  ReactDOM.render(<RequestOffer />, root);
}
